export default "__VITE_ASSET__Cd_s9AQQ__"